/**
 * Comentário apagado pelo autor (#6287). O registro continua no banco com o texto
 * e as imagens — quem apaga é a tela. Toda leitura de `comentarios_tarefas` que
 * vai para a tela passa por `ocultarSeApagado`, para o conteúdo não voltar por
 * outro caminho (aba de tarefas, atividade do projeto).
 */

export const TEXTO_COMENTARIO_APAGADO = 'Comentário apagado';

export function comentarioApagado(c: { apagado_em?: string | null } | null | undefined): boolean {
  return !!c?.apagado_em;
}

export function ocultarSeApagado<T extends { conteudo: string; anexos_url?: string[] | null; apagado_em?: string | null }>(
  c: T,
): T {
  return comentarioApagado(c) ? { ...c, conteudo: '', anexos_url: [] } : c;
}

/** Mensagem para o erro da função `apagar_comentario_tarefa`. */
export function mensagemErroApagarComentario(erro: { message?: string; code?: string } | null): string {
  const msg = erro?.message || '';
  // PGRST202 = função não existe no cache do PostgREST: o SQL ainda não rodou.
  if (erro?.code === 'PGRST202' || /apagar_comentario_tarefa/.test(msg)) {
    return 'Apagar comentário ainda não está liberado no banco. Avise o TI.';
  }
  return 'Não consegui apagar o comentário' + (msg ? `: ${msg}` : '.');
}
